import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { LanguageProvider } from "@/i18n";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { RateProvider } from "@/context/RateContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import PropertyDetail from "@/pages/PropertyDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import LegalPage from "@/pages/LegalPage";
import Blog from "@/pages/Blog";
import BlogArticle from "@/pages/BlogArticle";
import CostOfLiving from "@/pages/CostOfLiving";
import AssistantJose from "@/components/AssistantJose";
import { Toaster } from "@/components/ui/sonner";

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">…</div>;
  if (user === false) return <Navigate to="/connexion" replace />;
  if (requireAdmin && user.role !== "admin") return <Navigate to="/espace" replace />;
  return children;
};

const Layout = () => {
  const location = useLocation();
  const bare = ["/connexion", "/inscription"].includes(location.pathname);

  return (
    <>
      {!bare && <Navbar />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/biens" element={<Catalog />} />
          <Route path="/biens/:id" element={<PropertyDetail />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogArticle />} />
          <Route path="/cout-de-la-vie" element={<CostOfLiving />} />
          <Route path="/connexion" element={<Login />} />
          <Route path="/inscription" element={<Register />} />
          <Route path="/cgv" element={<LegalPage />} />
          <Route path="/confidentialite" element={<LegalPage />} />
          <Route path="/mentions-legales" element={<LegalPage />} />
          <Route path="/espace" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute requireAdmin><Admin /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      {!bare && <Footer />}
      {!bare && <AssistantJose />}
    </>
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (time) => { lenis.raf(time); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  return (
    <div className="App font-body">
      <div className="noise-overlay" />
      <LanguageProvider>
        <AuthProvider>
          <RateProvider>
            <BrowserRouter>
              <Layout />
            </BrowserRouter>
            <Toaster position="top-center" richColors />
          </RateProvider>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
